@if (!isAdminRoute) {
  <app-ticker></app-ticker>
  <app-navbar></app-navbar>
}
<router-outlet></router-outlet>
@if (!isAdminRoute) {
  <app-footer></app-footer>
}
